import Loadable from '../../components/loadable';

const ManageWebsiteContactUsCopy = Loadable({
  loader: () => import('../../pages/manage_website/contact_us_copy'),
});

angular.module('gym').value('ManageWebsiteContactUsCopy', ManageWebsiteContactUsCopy);
